/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { GetListingsSortBy } from './getListingsSortBy';
import type { GetListingsSortType } from './getListingsSortType';

export type GetListingsParams = {
pagination?: {
  skip?: number;
  limit?: number;
};
filter?: {
  txnType?: string;
  locationSlugs?: string;
  propertyTypes?: string;
  priceFrom?: number;
  priceTo?: number;
  areaFrom?: number;
  areaTo?: number;
  newBuildsOnly?: boolean;
  withVideo?: boolean;
  with3dTour?: boolean;
};
sort?: {
  by?: GetListingsSortBy;
  type?: GetListingsSortType;
};
};
